import React from 'react'

function Music() {
  return (
    <div><br /><br /><br /><br />
        <h1 align='center'><b>music Page</b> </h1><br /></div>
  )
}

export default Music